<script setup lang="ts">
import type { Dtwin } from "~/modules/dtwin/models/Dtwin.interface";
import type { DynamicUIDetail } from "~/modules/dtwin/models/DynamicUIDetail.interface";

interface Props {
  dtwin: Dtwin;
  deviceModelUiConfig: Record<string, DynamicUIDetail[]>;
}

defineProps<Props>();

const { t } = useI18n();

/*
TODO: uncomment this section when the battery attribute will be available
const batteryStatus: Ref<string> = ref(
  props.modelValue.batteryStatus?.toString() ?? NO_CONTENT,
);

const batteryStatusColorSuffix = computed(() => {
  if (props.modelValue.batteryStatus) {
    if (props.modelValue.batteryStatus <= 5) {
      return "error-700";
    } else if (props.modelValue.batteryStatus <= 25) {
      return "warning-600";
    } else {
      return "primary-600";
    }
  }
});*/
</script>

<template>
  <block-container
    :title="t(`dtwins.form.description.state.title`)"
    with-top-separator
  >
    <template #left>
      <dtwin-form-field
        v-for="item in deviceModelUiConfig.left"
        :key="item.id"
        :item="item"
        :dtwin="dtwin"
      />
    </template>
    <template #right>
      <dtwin-form-field
        v-for="item in deviceModelUiConfig.right"
        :key="item.id"
        :item="item"
        :dtwin="dtwin"
      />
    </template>
  </block-container>
</template>
